import(/* webpackMode: "eager", webpackExports: ["SlugMain"] */ "/app/src/app/(root)/[slug]/_components/slug-main.tsx");
